import React from 'react';
import './WDSerialBadge.css';

const WDSerialBadge = ({ text }) => {
  if (!text) return null;

  return (
    <div className="wd-serial-badge-wrapper">
      <div className="wd-serial-badge-bg">
        <span className="wd-serial-badge-text">C{text}</span>
      </div>
    </div>
  );
};

export default WDSerialBadge;